
function GetWords(text) {
  const words = text?.split(/\s+/); // split by one or more whitespace characters
    let result = "";
    for (let i = 0; i < Math.min(100, words?.length); i++) {
        result += words[i] + " ";
    }
    return result;
}

export default GetWords

export const GetLessWords = (text,wordLength=50) => {
  const words = text?.split(/\s+/); // split by one or more whitespace characters
    let result = "";
    for (let i = 0; i < Math.min(wordLength, words?.length); i++) {
        result += words[i] + " ";
    }
    return result;
}
